import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { initializeApp } from './actions'
import component from './component'


const mapStateToProps = state => ({
    cssModifiers: state.configuration.modifiers,
    wrapperDeviceType: state.wrapper.deviceType,
    isListEmpty: state.items.ids.length === 0,
    isFocusedItemsCreationForm: state.itemsCreationForm.isFocused
})

export default withRouter(connect(
    mapStateToProps,
    { initializeApp }
)(component))
